import { FC } from 'react'
import * as styles from 'components/features/pfm/RewardSummary/RadialProgressbar.css'
import cn from 'classnames'

type RadialProgressbarProps = {
  value: number
  theme?: 'blue' | 'green'
}

const RadialProgressbar: FC<RadialProgressbarProps> = (props) => {
  const { value, theme = 'green' } = props
  return (
    <svg className={ cn(styles.progressbar, styles[theme]) } viewBox='0 0 120 120'>
      <defs>
        <filter id='progressbarShadow' x='-50%' y='-50%' width='200%' height='200%'>
          <feComponentTransfer in='SourceAlpha'>
            <feFuncA type='table' tableValues='1 0' />
          </feComponentTransfer>
          <feGaussianBlur stdDeviation='2' />
          <feOffset dx='1.25' dy='-1' result='offsetblur' />
          <feFlood floodColor='rgba(0, 0, 0, 0.35)' result='color' />
          <feComposite in2='offsetblur' operator='in' />
          <feComposite in2='SourceAlpha' operator='in' />
          <feMerge>
            <feMergeNode in='SourceGraphic' />
            <feMergeNode />
          </feMerge>
        </filter>
      </defs>
      <linearGradient id='progressbarScaleGradient' x1='0%' y1='0%' x2='100%' y2='100%'>
        <stop offset='0%' stopColor='#f5dd4e' />
        <stop offset='50%' stopColor='#eaf639' />
        <stop offset='100%' stopColor='#f8e71c' />
      </linearGradient>
      <circle className={ styles.scale } cx='60' cy='60' r='54' filter='url(#progressbarShadow)' />
      <circle
        strokeDashoffset={ 359.9 - 270 * value }
        className={ styles.filling }
        cx='60'
        cy='60'
        r='54'
      />
    </svg>
  )
}

export default RadialProgressbar
